module.exports = __webpack_public_path__ + "img/pr.1d278b02.svg";